var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconDeveloperLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_developer_light"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.73343 8.06628C8.80511 8.06628 8.06676 8.80462 8.06676 9.73294V18.2663C8.06676 19.1946 8.80511 19.9329 9.73343 19.9329H22.2668C23.1951 19.9329 23.9334 19.1946 23.9334 18.2663V9.73294C23.9334 8.80462 23.1951 8.06628 22.2668 8.06628H9.73343ZM6.6001 9.73294C6.6001 7.9946 7.99509 6.59961 9.73343 6.59961H22.2668C24.0051 6.59961 25.4001 7.9946 25.4001 9.73294V18.2663C25.4001 20.0046 24.0051 21.3996 22.2668 21.3996H9.73343C7.99509 21.3996 6.6001 20.0046 6.6001 18.2663V9.73294Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.0001 25.3996H12.0001V23.9329H20.0001V25.3996Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2668 24.6663V20.6663H16.7334V24.6663H15.2668Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.875 13.9663L14.1113 11.7921L13.0889 10.7405L10.6889 13.0738L10.6816 13.0811C10.1952 13.5674 10.1952 14.3651 10.6816 14.8515L10.6889 14.8587L13.0889 17.1921L14.1113 16.1405L11.875 13.9663Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9113 10.7405L21.3113 13.0738L21.3186 13.0811C21.805 13.5674 21.805 14.3651 21.3186 14.8515L21.3113 14.8587L18.9113 17.1921L17.8889 16.1405L20.1252 13.9663L17.8889 11.7921L18.9113 10.7405Z",
    fill: "black"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDeveloperLight);
export default __webpack_public_path__ + "static/media/icon_developer_light.43b205ae.svg";
export { ForwardRef as ReactComponent };